import React from "react";
import { useTranslation } from "react-i18next";
import { Group, Input, NumberInput, Select } from "@mantine/core";
import { useFormatter } from "../hooks/useFomatter";

export const CURRENT_ASSETS_CURRENCY_OPTIONS = [
  { value: "HKD", label: "HKD" },
  { value: "USD", label: "USD" },
];

const ClientCurrentAssets = ({
  form: mainForm,
  label = "Current Assets Amount",
  disabled = false,
}) => {
  const { t } = useTranslation();
  const [formatter] = useFormatter();
  const currency =
    mainForm.values.currentAssetsCurrency || CURRENT_ASSETS_CURRENCY_OPTIONS[0].value;

  return (
    <Input.Wrapper label={t(label)}>
      <Group spacing="xs" align="flex-end" noWrap mt="xs">
        <Select
          style={{ width: 96 }}
          disabled={disabled}
          data={CURRENT_ASSETS_CURRENCY_OPTIONS}
          {...mainForm.getInputProps("currentAssetsCurrency")}
          value={currency}
        />
        <NumberInput
          style={{ flex: 1 }}
          disabled={disabled}
          parser={formatter.numberParser}
          formatter={formatter.numberFormat}
          {...mainForm.getInputProps("currentAssets")}
        />
      </Group>
    </Input.Wrapper>
  );
};

export default ClientCurrentAssets;
